/* src/app/_shared/components/client-info/client-info.component.scss */
:host {
  display: block;
}
app-item {
  border: 1px solid var(--ion-color-light) !important;
  border-radius: var(--radius);
  margin: 0;
  display: flex;
  flex-flow: row nowrap;
  --padding-top: 7px;
  --padding-bottom: 7px;
}
app-item app-avatar {
  --width: 65px;
  --height: 65px;
  margin-right: calc(var(--space-right) / 2);
}
/*# sourceMappingURL=client-info.component-363MVP2N.css.map */
